import { z } from 'zod';

export const AppEnvironment = z.enum(['development', 'sandbox', 'uat', 'production']);
export type AppEnvironment = z.infer<typeof AppEnvironment>;